// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"acee7955","513":"30030705"}[chunkId] + ".chunk.js";
};